export const mapOrder = (array, order, key) => {
  return array.sort((a, b) => {
    const A = Number(a[key]),
      B = Number(b[key]);

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });
};

export const sortArray = (array, key) => {
  return array.sort((a, b) => {
    if (a[key] === undefined || a[key] === null) return -1;
    if (b[key] === undefined || b[key] === null) return 1;
    return a[key] - b[key];
  });
};
